export default "__VITE_ASSET__DwrVIX8n__"